import announcementTypes from 'dashboard/actions/announcements/announcement-types';
import { setSelectedLanguage } from 'utils/actions/selected-language/selected-language.actions';

import template from './archived-announcements.html';

const mapStateToThis = ({ announcements }) => {
  const { isLoading, archived } = announcements;

  return {
    isLoading,
    archived,
  };
};

const mapDispatchToThis = {
  setSelectedLanguage,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class ArchivedAnnouncementsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.type = announcementTypes.ARCHIVED;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onLanguageSelect(locale) {
    this.setSelectedLanguage(locale);
  }
}

export default class ArchivedAnnouncementsComponent {
  constructor() {
    this.template = template;
    this.controller = ArchivedAnnouncementsController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/archived-announcements/archived-announcements-component.js